import {
  GET_GENERAL_INFO_INIT,
  GET_GENERAL_INFO_SUCCESS,
  GET_GENERAL_INFO_FAILURE,
  GET_CLIENT_INFO_INIT,
  GET_CLIENT_INFO_SUCCESS,
  GET_CLIENT_INFO_FAILURE,
} from '../actions/types';
import initialState from './initialState';

/**
 * Reducer for visualization and client information
 */
export default function (state = initialState.app, action) {
  switch (action.type) {
    // Cases to load the general info of the viz
    case GET_GENERAL_INFO_INIT:
      return {
        ...state,
        error: null,
        infoReady: false,
      };
    case GET_GENERAL_INFO_SUCCESS:
      return {
        ...state,
        vizInfo: action.payload,
        infoReady: true,
        error: null,
      };
    case GET_GENERAL_INFO_FAILURE:
      return {
        ...state,
        error: action.payload,
        infoReady: false,
      };

      // Cases to load the client info
    case GET_CLIENT_INFO_INIT:
      return {
        ...state,
        error: null,
      };
    case GET_CLIENT_INFO_SUCCESS:
      return {
        ...state,
        clientInfo: action.payload,
        error: null,
      };
    case GET_CLIENT_INFO_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
}
